export const DEFAULT_PROGRESS_STATE = {
    remainingSteps: 100 as number,
    remainingTime: (20 * 60) as number,
    steps: 0 as number,
    progress: 0 as number,
    progresses: [0, 0, 0, 0] as number[],
} as const;